// extracted by mini-css-extract-plugin
export default {"wrapper":"top-section_wrapper__GLYsh","shelfComponent":"top-section_shelfComponent__TNdO7"};